module.exports = __webpack_public_path__ + "img/logo.bb388fd2.png";